// Module
var code = "<svg width=\"9\" height=\"7\" viewBox=\"0 0 9 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M4.17157 6.30456L0.6 1.54246C0.352787 1.21284 0.587978 0.742463 1 0.742463L8.14314 0.742463C8.55516 0.742463 8.79035 1.21285 8.54314 1.54246L4.97157 6.30456C4.77157 6.57122 4.37157 6.57122 4.17157 6.30456Z\"/>\n</svg>\n";
// Exports
export default code;